import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getHowToUseListSaga = createAction(
  "GET_HOW_TO_USE",
  ({ payload, params }: SagaActionParams<Type.HowToUseDto[]>) => ({
    payload,
    url: "/api/admin/howtousecontents" + (params ? params : ""),
  })
);
export const getHowToUseDetailsSaga = createAction(
  "GET_HOW_TO_USE_DETAILS",
  ({ payload, id }: SagaActionParams<Type.HowToUseDetailDto>) => ({
    payload,
    url: "/api/admin/howtousecontents/" + id,
  })
);
export const createHowToUseSaga = createAction(
  "CREATE_HOW_TO_USE",
  ({ payload, body }: SagaActionParams<Type.HowToUseDto>) => ({
    payload,
    url: "/api/admin/howtousecontents",
    body,
  })
);
export const updateHowToUseSaga = createAction(
  "UPDATE_HOW_TO_USE",
  ({ payload, id, body }: SagaActionParams<Type.HowToUseDto>) => ({
    payload,
    url: "/api/admin/howtousecontents/" + id,
    body,
  })
);
export const deleteHowToUseSaga = createAction(
  "DELETE_HOW_TO_USE",
  ({ payload, id }: SagaActionParams<Type.HowToUseDto>) => ({
    payload,
    url: "/api/admin/howtousecontents/" + id,
  })
);

const howtouseSaga = [
  takeLatest<any>(
    getHowToUseListSaga.toString(),
    (payload: SagaGenericParams<Type.HowToUseDto[]>) =>
      getSaga<Type.HowToUseDto[]>(payload)
  ),
  takeLatest<any>(
    getHowToUseDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.HowToUseDetailDto>) =>
      getSaga<Type.HowToUseDetailDto>(payload)
  ),
  takeLatest<any>(
    createHowToUseSaga.toString(),
    (payload: SagaGenericParams<Type.HowToUseDto>) =>
      postSaga<Type.HowToUseDto>(payload)
  ),
  takeLatest<any>(
    updateHowToUseSaga.toString(),
    (payload: SagaGenericParams<Type.HowToUseDto>) =>
      putSaga<Type.HowToUseDto>(payload)
  ),
  takeLatest<any>(
    deleteHowToUseSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.HowToUseDto>(payload)
  ),
];

export default howtouseSaga;
